import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { applyMiddleware, createStore } from 'redux';
import translatorPortalApp, { initialState } from './reducers';

const middlewares = [
  thunkMiddleware, // lets us dispatch() functions
  // Dev-only. redux-logger console.logs prev-state, action, and next-state on every dispatch;
  // on the production bundle Chrome's console (and chromedriver's log-capture under Selenium)
  // retain those references and the retained state graph OOMs the Chrome 153+ renderer on the
  // offer-heavy /jobs page -- the same V8 "Ineffective mark-compacts near heap limit" that
  // blocked the beta pipeline today and reaches linguists who open devtools (TT P525324160).
  // Tests already ran without it (NODE_ENV === 'test'), so the Jest suites are unaffected.
  process.env.NODE_ENV === 'development' && createLogger(),
].filter(m => m);

const store = createStore(translatorPortalApp, initialState, applyMiddleware(...middlewares));

export default store;
